__turbopack_context__.v({
  "downvoteCounter": "VoteShare-module__sIpQjq__downvoteCounter",
  "downvotes": "VoteShare-module__sIpQjq__downvotes",
  "upvoteCounter": "VoteShare-module__sIpQjq__upvoteCounter",
  "upvotes": "VoteShare-module__sIpQjq__upvotes",
  "voteCounter": "VoteShare-module__sIpQjq__voteCounter",
  "voteCounterIcon": "VoteShare-module__sIpQjq__voteCounterIcon",
  "voteShare": "VoteShare-module__sIpQjq__voteShare",
  "voteShareBar": "VoteShare-module__sIpQjq__voteShareBar",
  "voteShareBarFill": "VoteShare-module__sIpQjq__voteShareBarFill",
  "voteShareCounters": "VoteShare-module__sIpQjq__voteShareCounters",
  "voteShareStats": "VoteShare-module__sIpQjq__voteShareStats",
});
